import { useState } from 'react'

import { ProfessionalContractType } from 'InstitutionalManagement/types'
import getProfessionalContractTypeOnCustomForm from './services/getProfessionalContractTypeOnCustomForm'

export default function useGetProfessionalContractTypeByID() {
  const [loadingProfessionalContractType, setLoadingProfessionalContractType] = useState<boolean>(false)
  const [professionalContractType, setProfessionalContractType] = useState<ProfessionalContractType>({})

  async function getProfessionalContractType(professionalContractTypeId?: string) {
    setLoadingProfessionalContractType(true)
    const response = await getProfessionalContractTypeOnCustomForm({
      professionalContractTypeId: professionalContractTypeId as string,
    })
    let professionalContractTypeFromAPI: ProfessionalContractType = {}
    if (response?.header?.success) {
      professionalContractTypeFromAPI = response?.body?.contract_type
      setProfessionalContractType(professionalContractTypeFromAPI)
    }
    setLoadingProfessionalContractType(false)
    return professionalContractTypeFromAPI
  }

  return { getProfessionalContractType, professionalContractType, loadingProfessionalContractType }
}
